import { Component, Input } from '@angular/core';
import { publicMethods } from '../../../globals';
import { magicPreviewDummyData } from '../../../classes/company';
import { DonutDataInput } from '../../html-snippet-components/donut-chart/donut-chart.component';

@Component({
    selector: 'aira-pie-chart',
    templateUrl: './aira-pie-chart.component.html',
    styleUrl: './aira-pie-chart.component.css',
    standalone: false
})
export class AiraPieChartComponent {
  @Input() label = '';
  @Input() data;
  @Input() labelName;
  @Input() valueName;
  @Input() append = '';
  @Input() total: number;
  @Input() baseLabel: string;
  @Input() remainderLabel: string;
  @Input() previewOnly: boolean = false;
  @Input() colours: string[] | null = null;
  @Input() width: number | null = null;
  @Input() totalLabelOverride: string | null = null;
  @Input() totalCountOverride: number | null = null;

  chartOptions: any;
  labels = [];
  series = [];
  // The child chart rebuilds only when this object's identity changes, so it is
  // stored rather than built inline in the template.
  donutInput: Partial<DonutDataInput> = { series: [] };
  baseColour = '#4A2673';

  labelNameToTotalLabelMap = {
    country_code: 'regions',
    country_name: 'regions',
    currency: 'currencies',
    B2C: 'markets',
  };

  constructor(public pubMethods: publicMethods) {}

  ngOnInit(): void {
    this.rebuildChartData();
  }

  ngOnChanges(): void {
    this.rebuildChartData();
  }

  rebuildChartData(): void {
    this.series = [];
    this.labels = [];
    if (this.previewOnly) {
      this.replaceWithDummyData();
    } else {
      this.handleDifferentDataType();
    }
    this.donutInput = {
      series: this.series,
      legendLabels: this.labels,
      chartType: 'donut',
      width: this.width || 320,
      totalLabel: this.getTotalLabel(),
      totalCount: this.totalCountOverride ?? undefined,
      tooltipAppend: this.append,
      colours: this.colours || undefined,
    };
  }

  replaceWithDummyData(): void {
    this.series = [...magicPreviewDummyData.dataForDummyDonut.series];
    this.labels = [...magicPreviewDummyData.dataForDummyDonut.labels];
  }

  handleDifferentDataType(): void {
    if (Array.isArray(this.data)) {
      this.convertKeyValuesIntoSeriesAndLabels();
    } else if (typeof this.data === 'number') {
      const total = this.total || 100;
      const baseNum = this.data;
      const remainder = total - this.data;
      this.series.push(baseNum, remainder);
      this.labels.push(this.baseLabel, this.remainderLabel);
    }
  }

  convertKeyValuesIntoSeriesAndLabels(): void {
    for (const item of this.data) {
      this.series.push(parseFloat(item[this.valueName]));
      this.labels.push(item[this.labelName]);
    }
  }

  getTotalLabel(): string {
    if (this.totalLabelOverride) return this.totalLabelOverride;
    if (this.labelName) {
      return this.labelNameToTotalLabelMap[this.labelName];
    } else if (this.baseLabel) {
      return this.labelNameToTotalLabelMap[this.baseLabel];
    }
  }
}
